import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { BackResponseFailure } from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.document}files?token=${COMMON_QUERY_PARAMS.DOCUMENT_ID}`;

export interface DownloadDocumentArgs {
  tokenId: string;
}

export default async function downloadDocument(
  payload: DownloadDocumentArgs,
): Promise<Blob | BackResponseFailure> {
  try {
    return await apiCall<Blob>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.DOCUMENT_ID, payload.tokenId),
      {
        method: SUPPORTED_METHODS.GET,
        responseType: 'blob',
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
